export default function discountModalHandler() {
  const modal = document.getElementById("discount-modal");
  if (!modal) {
    return;
  }

  const form = document.getElementById("discount-capture-form");
  const modalBody = modal.querySelector(".discount-modal__body");
  const submitButton = modal.querySelector(".btn-submit-discount");
  const emailInput = document.getElementById("discount-email");
  const phoneInput = document.getElementById("discount-phone");

  // Use our new, dedicated variables. Fallback for safety.
  const modalVars = window.discountModalVars || {
    texts: {},
    nonce: "",
    ajaxUrl: "",
  };
  const t = (key, fallback) => modalVars.texts[key] || fallback;

  if (!form || !modalBody || !submitButton || !emailInput || !phoneInput) {
    return;
  }

  const showMessage = (message, type = "error") => {
    const existingMessage = form.querySelector(".form-message");
    if (existingMessage) {
      existingMessage.remove();
    }

    const messageEl = document.createElement("div");
    messageEl.className = `form-message ${type}`;
    messageEl.textContent = message;

    form.insertBefore(messageEl, submitButton);
  };

  const validateForm = () => {
    const email = emailInput.value.trim();
    const phone = phoneInput.value.trim();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email || !phone) {
      showMessage(t("error_required", "All fields are required."));
      return false;
    }

    if (!emailRegex.test(email)) {
      showMessage(
        t("error_invalid_email", "Please enter a valid email address.")
      );
      return false;
    }

    if (phone.length < 7) {
      showMessage(
        t("error_invalid_phone", "Please enter a valid phone number.")
      );
      return false;
    }

    const existingMessage = form.querySelector(".form-message");
    if (existingMessage) {
      existingMessage.remove();
    }

    return true;
  };

  const showSuccessState = (message) => {
    const successDiv = document.createElement("div");
    successDiv.className = "discount-modal__success";
    successDiv.innerHTML = `<p>${message}</p>`;

    modalBody.innerHTML = "";
    modalBody.appendChild(successDiv);
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();

    if (!validateForm()) {
      return;
    }

    const originalButtonText = submitButton.textContent;
    submitButton.disabled = true;
    submitButton.textContent = t("sending", "Sending...");

    const formData = new FormData(form);
    formData.append("action", "handle_discount_modal_request");
    formData.append("nonce", modalVars.nonce); // <-- USE THE CORRECT NONCE

    try {
      const response = await fetch(modalVars.ajaxUrl, {
        method: "POST",
        body: formData,
      });

      // Check if the response is OK (status 200-299)
      if (!response.ok) {
        // This will handle 403, 404, 500 etc. errors gracefully
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }

      const data = await response.json();

      if (data.success) {
        showSuccessState(data.data.message);
        setTimeout(() => {
          const closeButton = modal.querySelector(".discount-modal__close");
          if (closeButton) {
            closeButton.click();
          }
        }, 4000);
      } else {
        // Handle application-level errors (e.g., email already exists)
        showMessage(
          data.data.message || t("error_general", "An error occurred.")
        );
      }
    } catch (error) {
      // Handle network errors or failed JSON parsing
      console.error("Discount Modal Error:", error);
      showMessage(t("error_general", "An error occurred. Please try again."));
    } finally {
      // This block runs regardless of success or failure
      if (!submitButton.closest(".discount-modal__success")) {
        // Don't re-enable if success state is shown
        submitButton.disabled = false;
        submitButton.textContent = originalButtonText;
      }
    }
  };

  form.addEventListener("submit", handleFormSubmit);
}
